import React, { Component } from "react";
import StepWizard from 'react-step-wizard';
//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import Paso1 from "./PrestamoPaso1";
import Paso2 from "./PrestamoPaso2";
import Paso3 from "./PrestamoPaso3";
import Paso4 from "./PrestamoPaso4";


export default class PagoPrestamo extends Component {
  constructor(props) {
    super(props);
    this.refPaso1 = React.createRef();
    this.refPaso2 = React.createRef();
    this.refPaso3 = React.createRef();
    this.refPaso4 = React.createRef();
    this.state = {
      rptPaso1: undefined,
      rptPaso2Cuenta: undefined,
      rptPaso2CuentaDet: undefined,
      rptPaso2Cuotas: undefined,
      rptPaso2TipoPrestamo: undefined,
      rptPaso2NroPrestamo: undefined,
      rptPaso2MontoPrestamo: undefined,
      rptPaso2Moneda: undefined,
      rptPaso2AlDia: undefined,
      rptPaso3: undefined,
    };
  }

  componentDidMount() {
    var resumen = sessionStorage.getItem("prestamo")
    //console.log(resumen)
    if (resumen === null)
      console.log("NINGUNO")
    else {
      var tipo = sessionStorage.getItem("tipo")
      var moneda = sessionStorage.getItem("moneda")
      var capital = sessionStorage.getItem("capital")
      var alDia = sessionStorage.getItem("alDia")
      this.setState(
        {
          rptPaso1: resumen,
          rptPaso2Moneda: moneda,
          rptPaso2MontoPrestamo: capital,
          rptPaso2NroPrestamo: resumen,
          rptPaso2TipoPrestamo: tipo,
          rptPaso2AlDia: alDia
        }
      )
      sessionStorage.removeItem("prestamo")
      sessionStorage.removeItem("capital")
      sessionStorage.removeItem("moneda")
      sessionStorage.removeItem("tipo")
      sessionStorage.removeItem("alDia")


      this.refPaso2.current.getDetalles(resumen)
      this.refPaso1.current.nextStep.click()
    }
  }
  /*
    rptPaso1 = (respuesta) => {
      this.setState({ rptPaso1: respuesta.substr(6, respuesta.length) }, this.enableNextPaso1);
    }*/
  rptPaso1 = (id, tipoPrestamo, nroPrestamo, montoPrestamo, moneda, alDia) => {
    this.setState(
      {
        rptPaso1: id.substr(6, id.length),
        rptPaso2TipoPrestamo: tipoPrestamo,
        rptPaso2MontoPrestamo: montoPrestamo,
        rptPaso2NroPrestamo: nroPrestamo,
        rptPaso2Moneda: moneda,
        rptPaso2AlDia: alDia
      },
      this.enableNextPaso1
    );
  }

  enableNextPaso1() {
    this.refPaso1.current.checkGrilla();
  }
  paso1Next = () => {

    this.refPaso2.current.getDetalles(this.state.rptPaso1)
    this.refPaso1.current.nextStep.click()
  };

  rptPaso2Cuenta = (respuesta) => {

    this.setState({ rptPaso2Cuenta: respuesta.value, rptPaso2CuentaDet: respuesta.label });

  }

  rptPaso2Cuotas = (respuesta) => {
    //console.log("INGRESA CUOTAS " + respuesta)
    this.setState({ rptPaso2Cuotas: respuesta });

  }

  paso2Next = () => {


    this.refPaso3.current.obtenerDatos(this.state.rptPaso1, this.state.rptPaso2Cuotas, this.state.rptPaso2Cuenta)
    this.refPaso2.current.nextStep.click()
  };

  paso3Next = () => {

    this.setState({ rptPaso3: this.refPaso3.current.state.datosCuenta, });

    this.refPaso4.current.obtenerDatos(this.state.rptPaso1, this.state.rptPaso2Cuotas, this.state.rptPaso2Cuenta)
    this.refPaso3.current.nextStep.click()
  };

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Pago de Préstamo" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <StepWizard transitions='none'>
                      <Paso1 ref={this.refPaso1} rptPaso1={this.rptPaso1.bind(this)} paso1Next={this.paso1Next.bind(this)} />
                      <Paso2 ref={this.refPaso2} rptPaso2Cuotas={this.rptPaso2Cuotas.bind(this)} rptPaso2Cuenta={this.rptPaso2Cuenta.bind(this)} paso2Next={this.paso2Next.bind(this)}
                        nroPrestamo={this.state.rptPaso2NroPrestamo}
                        montoPrestamo={this.state.rptPaso2MontoPrestamo}
                        tipoPrestamo={this.state.rptPaso2TipoPrestamo}
                        moneda={this.state.rptPaso2Moneda}
                        alDia={this.state.rptPaso2AlDia} />
                      <Paso3 ref={this.refPaso3} prestamo={this.state.rptPaso1} debito={this.state.rptPaso2CuentaDet} paso3Next={this.paso3Next.bind(this)} />
                      <Paso4 ref={this.refPaso4} prestamo={this.state.rptPaso1} debito={this.state.rptPaso2CuentaDet} datosCuenta={this.state.rptPaso3} moneda={this.state.rptPaso2Moneda} />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    );
  }
}